import { listInterview } from "@endpoints/interview.service";
import { groupedGeneralMeetings } from "../SchedulingSection/SchedulingSection";
import { useEffect, useRef, useState } from "react";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import { isObjectEmpty } from "@utils/helperFunction";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {
  IGetInterviewByIdResponse,
} from "@endpoints/types/interview.type";
import { Months, ScheduledMeeting } from "./dummyData";
import { useSnackbar } from "notistack";

export function getMeetingStatus(item: IGetInterviewByIdResponse) {
  if (
    item?.interviewStatus !== "Declined" &&
      item?.slotSelectionType === "general"
      ? !item?.isCandidateConfirm && !item?.isCompanyConfirm
      : !item?.isCandidateConfirm && !item?.isRecruiterAgencyConfirm
  ) {
    return {
      label: "Action Required",
      textStyle: "text-orange-400",
      buttonStyle: "border-orange-400",
    };
  } else if (
    item?.interviewStatus !== "Declined" &&
      item?.slotSelectionType === "general"
      ? item?.isCandidateConfirm && item?.isCompanyConfirm
      : item?.isCandidateConfirm && item?.isRecruiterAgencyConfirm
  ) {
    return {
      label: "Accepted",
      textStyle: "text-green-500",
      buttonStyle: "border-green-500",
    };
  } else if (
    item?.interviewStatus !== "Declined" &&
      item?.slotSelectionType === "general"
      ? item?.isCompanyConfirm || item?.isRecruiterAgencyConfirm
      : item?.isRecruiterAgencyConfirm || item?.isCandidateConfirm
  ) {
    return {
      label: "Pending",
      textStyle: "text-blue-500",
      buttonStyle: "border-blue-500",
    };
  } else if (item?.interviewStatus === "Declined") {
    return {
      label: "Declined",
      textStyle: "text-red-500",
      buttonStyle: "border-red-500",
    };
  }
}

const ScheduleCard = ({ item, title }) => {
  const navigate = useNavigate();
  const isCurrentMonth = (dayjs().format('MMMM') === title) && dayjs(item?.specificSlot?.startTime).isAfter(dayjs(), 'days')
  const isCurrentDate = dayjs(item?.specificSlot?.startTime).isSame(dayjs(), 'days')
  const dateTime = item?.specificSlot?.startTime
  const isHiringCompanyInvolved = !!item?.hiringCompanyId?._id;
  const attendees = isHiringCompanyInvolved ? ["RA", "CA", "HC"] : ["RA", "CA"];
  const buttonInfo = getMeetingStatus(item);

  return (
    <div
      // onClick={() => navigate(`/meeting-details?id=${item?._id}`)}
      className={`items-center pl-3 grid grid-cols-[0.5fr_1.5fr] cursor-pointer hover:bg-gray-50 flex-1`}
    >
      <div className="flex">
        <div
          className={`h-20 w-[2px] ${
            isCurrentDate
              ? "bg-green-500"
              : isCurrentMonth
              ? "bg-blue-400"
              : "bg-transparent"
          } mr-2`}
        ></div>
        <div className="flex flex-col gap-3 h-full">
          <span className="font-semibold text-primary text-sm">{dayjs(dateTime)?.format('ddd')} {dayjs(dateTime)?.format('DD')}</span>
          <span className="font-semibold text-primary text-xs">12:30pm - 1:30pm(GMT)</span>
          <div className="flex items-center gap-2">
            <span className="text-xs text-light-black font-medium">Meeting in</span>
            <span className="text-sm text-primary font-semibold italic">4hrs 30min</span>
          </div>
        </div>
      </div>
      <div className="flex items-center border-b py-6">
        <div className="flex flex-col gap-2 flex-1">
          <div className="flex items-center justify-center rounded-md bg-gray-100 w-28 py-1.5 font-medium text-xs">Confirmed</div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-light-black font-medium">Meeting Type:</span>
            <span className="text-sm text-primary font-semibold">React Native Interview</span>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-xs text-light-black font-medium">Your attendance:</span>
            <span className="text-sm text-primary font-semibold italic">Not Required</span>
          </div>
        </div>
        <div className="flex flex-col gap-2.5 flex-1">
          <div className="flex items-center gap-2">
            <span className="text-xs text-light-black font-medium">Title:</span>
            <span className="text-sm text-primary font-semibold">React Native Interview</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs text-light-black font-medium">Position:</span>
            <span className="text-sm text-primary font-medium">React Native Developer</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs font-medium text-light-black">Attendees</span>
            <div className="flex items-center gap-2">
              {
                ['RA', 'CA', 'HC']?.map((item) => {
                  return <div className="h-9 w-9 flex items-center justify-center border rounded-full text-xs font-semibold">{item}</div>
                })
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const MonthSection = ({ activeMonth, schedulingPolls, onClick }) => {
  const currentMonth = dayjs().format('MMMM')
  return <div className="flex flex-col w-32 border rounded-md h-max">
    {
      Months?.map((month, monthIndex) => {
        const isCurrentMonth = month === currentMonth
        const isActiveMonth = month === activeMonth
        const dataCount = schedulingPolls?.find((item) => item?.title === month)?.data?.length
        return <button onClick={() => onClick(month)} className={`flex items-center gap-1 h-10 font-medium text-xs py-2.5 px-1 pr-3 hover:bg-gray-50 text-left
          ${isActiveMonth ? 'bg-gray-100' : ''}
          ${monthIndex !== 0 ? 'border-t' : ''}`}>
          <div className={`h-full w-[2px] ${isCurrentMonth ? 'bg-secondary' : 'bg-transparent'} rounded-md`} />
          {month}
          {dataCount ?
            <div className="flex items-center justify-center ml-auto rounded-full bg-secondary text-white h-5 w-5 font-semibold">{dataCount}</div>
            :
            null}
        </button>
      })
    }
  </div>
}

const ScheduleSection1 = () => {
  const { enqueueSnackbar } = useSnackbar()
  const itemRefs = useRef([])
  const scrollRef = useRef(null)
  const [isEventLoading, setIsEventLoading] = useState(true);
  const [activeMonth, setActiveMonth] = useState('')
  const [schedulingPolls, setSchedulingPolls] = useState([]);

  useEffect(() => {
    if (schedulingPolls?.length) {
      const title = dayjs().format('MMMM YYYY')
      itemRefs.current[title]?.scrollIntoView({
        behavior: "smooth",
        block: 'center',
      });
    }
    if (!scrollRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        // Find the first section that is intersecting from the top
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const title = (entry.target as HTMLElement).dataset.title;
            if (title) {
              setActiveMonth(title);
            }
          }
        });
      },
      {
        root: scrollRef.current,
        // Create a detection line at the top of the container
        // This triggers when a section's top edge crosses the top of the scroll container
        rootMargin: '-1px 0px -99% 0px',
        threshold: 0,
      }
    );

    Object.values(itemRefs.current).forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();

  }, [schedulingPolls])

  useEffect(() => {
    // @ts-ignore
    setSchedulingPolls(groupedGeneralMeetings(ScheduledMeeting))
    listInterview({
      isSchedule: true,
    })
      .then((response) => {
        const { success, data } = response;
        if (success) {
          // data?.map((item) => {
          //   deleteInterview(item?._id);
          // });
          // setSchedulingPolls(() => groupedGeneralMeetings(data));
          console.log('schedulingPolls', data, groupedGeneralMeetings(data))
          // setEvents(() => formatEvents(data));
        }
      })
      .finally(() => setIsEventLoading(false));
  }, []);


  return (
    <div className="flex flex-1 w-full gap-8">
      <div className="flex flex-col flex-1 min-h-0">
        {/* Sticky header showing active month */}
        {activeMonth && (
          <div
            className={`flex items-center py-2 px-3 gap-4 bg-[#F1F5F9] rounded-md sticky top-0 z-10`}
          >
            <label className="font-bold text-sm m-auto">{activeMonth}</label>
          </div>
        )}
        <div
          ref={scrollRef}
          className="min-h-0 flex-col flex flex-1 overflow-y-scroll no-scrollbar mt-3">
          <div
            className="flex flex-col gap-7">
            {
              schedulingPolls?.map((item, itemIndex) => {
                return <div key={item?.title || itemIndex}
                  ref={(el) => {
                    if (el) itemRefs.current[item?.title || itemIndex] = el
                  }}
                  data-title={item?.title}
                  className="flex flex-col">
                  {!item?.data?.length ?
                    <span className="text-xs font-medium m-auto mt-4 text-light-black">No meeting scheduled</span>
                    :
                    item?.data.map((meeting, meetingIndex) => (
                      <ScheduleCard
                        key={meeting?._id}
                        item={meeting}
                        title={item?.title}
                      />
                    ))
                  }
                </div>
              })
            }
          </div>
        </div>

      </div>
      <MonthSection activeMonth={activeMonth} schedulingPolls={schedulingPolls} onClick={(month) => {
        const hasData = schedulingPolls?.find((item) => item?.title === month)?.data?.length
        if (!hasData) {
          enqueueSnackbar('No meeting available on this month', { variant: 'warning' })
        } else {
          // Scroll to the top of the clicked month's group
          itemRefs.current[month]?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          })
        }
      }} />
    </div>
  );
};

export default ScheduleSection1;
